import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Czechmate Consulting',
    description:
        'Orthodontic practice coaching from Dr. Brad Chvatal in Eugene, Oregon. Real strategy to grow your practice and build a life you actually want to live.',
    url: 'https://czechmateconsulting.com',
    // Share images resolve against the site's CDN, which serves the same
    // /images/czechmate/* files, so link previews work on any domain.
    assetsUrl: 'https://czechmateconsulting.cdn.modulify.website',
    ogImage: '/images/czechmate/og-image.jpg',
    links: {
        facebook: 'https://www.facebook.com/61568586167206'
    }
}

export const contact = {
    email: 'bchvatal@gmail.com',
    officePhone: '(503) 850-8433',
    officePhoneHref: 'tel:+15038508433',
    consultationPhone: '(541) 521-9806',
    consultationPhoneHref: 'tel:+15415219806',
    city: 'Eugene',
    region: 'Oregon',
    regionCode: 'OR',
    street: '1400 Valley River Drive, Suite 240',
    postalCode: '97401',
    country: 'US'
}
